import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/details',
    component: () => import(/* webpackChunkName: "details" */ '@/views/Details.vue'),
    children: [
      {
        path: 'sessions/:ids',
        component: () => import(/* webpackChunkName: "details" */ '@/views/details/Sessions.vue'),
      },
      {
        path: 'presentations/:id',
        component: () => import(/* webpackChunkName: "details" */ '@/views/details/Presentation.vue'),
      },
      {
        path: 'persons/:id',
        component: () => import(/* webpackChunkName: "details" */ '@/views/details/Person.vue'),
      }
    ]
  },
  {
    path: '/program/:key', 
    component: () => import(/* webpackChunkName: "program" */ '@/views/Program.vue'),
    children: [
      {
        path: 'horizontal',
        component: () => import(/* webpackChunkName: "program" */ '@/views/program/Horizontal.vue'),
      },
      {
        path: 'vertical',
        component: () => import(/* webpackChunkName: "program" */ '@/views/program/Vertical.vue'),
      },
      {
        path: 'list',
        component: () => import(/* webpackChunkName: "program" */ '@/views/program/List.vue'),
      }
    ]
  },
  {
    path: '/persons',
    component: () => import(/* webpackChunkName: "persons" */ '@/views/Persons.vue')
  },
  {
    path: '/abstractspresenters',
    component: () => import(/* webpackChunkName: "persons" */ '@/views/AbstractsPresenters.vue')
  },
  {
    path: '/favorites',
    component: () => import(/* webpackChunkName: "favorites" */ '@/views/Favorites.vue'),
    beforeEnter(to, from, next) {
      if (!store.state.key && !store.state.flave) {
        store.commit('setModal', true);
        return;
      }
      if (!store.state.key && store.state.flave) {
        return;
      }
      next();
    }
  },
  {
    path: '/results',
    component: () => import(/* webpackChunkName: "help" */ '@/views/Results.vue')
  },
  {
    path: '/set/:params',
    component: () => import(/* webpackChunkName: "set" */ '@/views/Set.vue')
  },
  {
    path: '/pdf',
    component: () => import(/* webpackChunkName: "help" */ '@/views/Pdf.vue')
  },
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue')
  },
  {
    path: '/help',
    component: () => import(/* webpackChunkName: "help" */ '@/views/Help.vue')
  },
  {
    path: '/program',
    redirect: '/program/1/horizontal',
  },
  {
    path: '/',
    redirect: '/program/1/horizontal',
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach(async (to, from, next) => {
  const key = localStorage.getItem('x-api-key') || null;
  if (key) {
    store.state.key = key;
    await store.dispatch('getUser');
  }
  if (Object.keys(store.state.settings).length === 0) {
    await store.dispatch('initializeProgram');
  }
  next()
})

export default router
